import { Dispatch } from 'redux';
import { OrtService, StringDTO } from '../../api';
import { ActionTypes, ReduxAction } from './types';

export const searchOrte =
  (ortsname?: string, plz?: string, landId?: number) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    new OrtService().searchOrte(ortsname, plz, landId).then(response => {
      dispatch({
        type: ActionTypes.SEARCH_ORTE,
        payload: response.data,
      });
    });
  };
